import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-494d1a95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between items-center mb-5" }
const _hoisted_2 = { class: "text-3xl font-bold" }

import { computed, onBeforeMount } from "vue" 
import { modalClosed } from "@/mixins/visualFormatters";
import { blurBackground } from "@/mixins/visualFormatters";

export default /*#__PURE__*/_defineComponent({
  __name: 'acMediumModal',
  props: {
title: {
            type: String,
            required: false,
        },
        height:{
            type: String,
            required: true,
        },

        width: {
            type: String,
            required: true
        }
},
  emits: ['modal-closed'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const emitModalClosed = function(){
    modalClosed();
    emit('modal-closed')
}

const cssVars = computed(() => {
        return {
            '--modal-height': props.height,
            '--modal-width': props.width
        }
})

onBeforeMount(() => {
    blurBackground()
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(cssVars.value),
    class: "ac-modal"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("button", {
        class: "modal-close",
        onClick: emitModalClosed
      }, " ✕ ")
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})